import { memo } from 'react';
import { CellContext } from '@tanstack/react-table';
import { getFormTableFieldName } from './utils';
import { FormField } from '../../FormField';
import { FormInput } from '../../input';

export const FormTableDefaultField = (memo as <T>(c: T) => T)(
  <RowData,>(props: CellContext<RowData, any>) => {
    const name = getFormTableFieldName(props);
    return (
      <FormField name={name} size="small" preview>
        <FormInput name={name} size="small" autoFocus />
      </FormField>
    );
  }
);
